// extracted by mini-css-extract-plugin
export var breadcrumbs = "BreadCrumbs-module--breadcrumbs--993H2";
export var spacer = "BreadCrumbs-module--spacer--lQNGb";
export var crumb = "BreadCrumbs-module--crumb--Mlfff";